import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'header-marketplace',
  template: `
    <div
      class="alain-default__nav-item hide-this"
      (click)="openMarketplace()"
      nz-tooltip
      nzTooltipTitle="Marketplace"
      nzTooltipPlacement="bottom"
    >
      <i nz-icon nzIconfont="icon-marketplace-white"></i>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HeaderMarketplaceComponent {
  constructor(private router: Router) {}
  openMarketplace() {
    this.router.navigate(['./marketplace']);
  }
}